import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PasswordInputComponent } from './password-input.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
  ],
  declarations: [
    PasswordInputComponent,
  ],
  exports: [
    PasswordInputComponent,
  ],
})
export class PasswordInputModule { }
